import {CareerFrameworkController} from 'components/career_frameworks/career_framework_controller';
import {useEffect} from 'react';
import {Helmet} from 'react-helmet';
import {ANALYTICS_EVENTS, sendTimeSpentEvent} from 'utilities/analytics';

export const CareerFrameworks = () => {
  useEffect(() => {
    const startTime = Date.now();
    return () => {
      const endTime = Date.now();
      const timeSpentSec = (endTime - startTime) / 1000;
      sendTimeSpentEvent(
        ANALYTICS_EVENTS.CAREER_FRAMEWORKS.TIME_SPENT,
        timeSpentSec,
        'Career Frameworks'
      );
    };
  }, []);
  return (
    <>
      <Helmet>
        <title>Career Frameworks - SPRiTEs-GPT</title>
      </Helmet>
      <CareerFrameworkController />
    </>
  );
};
